import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import { QIDIAN_EXPAND, TODAY_CALL_CUSTOMERS } from '../constant'

Vue.use(Vuex)
/**
 * tabData的item示例
 * 	key: 页签唯一标识
 * 	name: 页签名
 * 	url： 页签地址
 * 	icon：页签图标
 */
const state = {
	lang: localStorage.getItem('i18nextLng') || 'zh-CN',
	menuList:[],
  rawMenuData:{},
	tabData: [],
	activeTabKey: '',
	// 抽屉支持两种模拟：url形式;自定义组件形式(需要type和data两个属性)
	drawerInfo: {
		title: '', // 标题
		drawerShow: false, // 是否显示抽屉
		drawerWidth: '30%',
		options: undefined, // 抽屉效果控制，{model,blur}

		drawerSrc: '', // 抽屉嵌入的iframe 地址

		type: '',
		data: '',
	},
	userInfo: {}, // 用户信息
  otherSystemConfig: {}, // 其他系统配置
  callRecords: [], // 本地保存的通话记录

	dialogInfo: {
		title: '', // 标题
		visible: false, // 是否显示

		src: '',
	},

	// 悬浮菜单项
	floatBarMenu: [],
  // 企点电话条是否展开
  qidianExpand: localStorage.getItem(QIDIAN_EXPAND) === '1' ? true : false,
  // 今日通话客户信息（记录第三方客户信息）
  todayCallCustomers: JSON.parse(localStorage.getItem(TODAY_CALL_CUSTOMERS)) || {}
}

const store = new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js